/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 12/1/14
 * Time: 4:44 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var Template = require("personalization-web-agent-templates/acdAnchor.tmpl");
    var Button = require("ui/button/Button");
    var AcdEditView = require("personalization-web-agent-views/AcdEditView");
    var BaseAnchorView = require("personalization-views/BaseAnchorView");
    var positionsUtility = require("personalization-utils/positionsUtility");
    var KpContent = require("ui.components/kpContent/kpContent");

    var AcdAnchor = {};
    LE.module('LEPersonalization', function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        AcdAnchor = BaseAnchorView.extend({
            template: Template,
            withUIComponents: true,
            className: "acd-anchor-view anchor",
            ui: {
                acdEditButton: ".acd-edit-button",
                knowledgePack: ".kp"
            },
            uiComponents: {
                editButton: {
                    type: Button,
                    options: {
                        el: "view.ui.acdEditButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY
                    },
                    events: {
                        "click": "_onEditButtonClick"
                    }
                },
                kpContent: {
                    type : KpContent,
                    options : {
                        container: "view.ui.knowledgePack",
                        contentPermutation: KpContent.CONTENT_PERMUTATION.INLINE,
                        KPLink: LE.translator.translate("LEPersonalization.webAgent.ACD.title.learnMore"),
                        kpID: "change-queue-options"
                    }
                }
            },

            initialize: function (options) {
                this.anchorSelector = options.anchorSelector;
                this.featureId = options.featureId;
                BaseAnchorView.prototype.initialize.call(this, options);
                var textKey = this.options.isMessaging ? "LEPersonalization.webAgent.ACD.text.messaging" : "LEPersonalization.webAgent.ACD.text";

                this.model.set("subtitleText", LE.translator.translate(textKey));
                // this.container=options.container;
            },
            onRender: function (options) {
                var offset = positionsUtility.getOffset(this.anchorSelector, positionsUtility.POSITION_X.LEFT, positionsUtility.POSITION_Y.BOTTOM);
                if (offset) {
                    this.$el.css(offset);
                }
            },

            _onEditButtonClick: function () {
                this.trigger("acd:navigateToFeatureEdit");
            }
        });
    });

    return AcdAnchor;

});